import {BrowserModule, Title} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
// @ts-ignore
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatChipsModule} from '@angular/material/chips';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {TimerAndTaskComponent} from './timer-and-task/timer-and-task.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {BlogComponent} from './blog/blog.component';
import {FeedbackComponent} from './feedback/feedback.component';
import {StatisticsComponent} from './statistics/statistics.component';
import {SettingComponent} from './setting/setting.component';
import {FooterComponent} from './footer/footer.component';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {MenuComponent} from './menu/menu.component';
import {MatMenuModule} from '@angular/material/menu';
import {ForDebugComponent} from './for-debug/for-debug.component';
import {CountdownModule} from 'ngx-countdown';
import {MatTableModule} from '@angular/material/table';
import {PomodoroRepository} from './Models/PomodoroRepository';
import {MatButtonModule} from '@angular/material/button';
import {LoginComponent} from './auth/login/login.component';
import {ProfileComponent} from './profile/profile.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {AppConfig} from './app.config';
import {ReversePipe} from './pipes/reverse.pipe';
import {RegisterComponent} from './auth/register/register.component';
import {VerifyComponent} from './auth/verify/verify.component';
import {UserService} from './services/user.service';
import {PreventLoginAccess} from './preventLoginAccess';
import {EditProfileComponent} from './edit-profile/edit-profile.component';
import {TaskService} from './services/task.service';
import {HeaderComponent} from './header/header.component';
import {ComingSoonComponent} from './coming-soon/coming-soon.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {AngularFireModule} from '@angular/fire';
import {NotificationService} from './services/notification.service';
import {PushNotificationsModule} from 'ng-push-ivy';
import {PasswordComponent} from './auth/password/password.component';
import {ForgetPassComponent} from './auth/forget-pass/forget-pass.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {OnlyNumberDirective} from './directives/only-number.directive';
import {NumberLimitDirective} from './directives/number-limit.directive';
import {NgxPaginationModule} from 'ngx-pagination';
import {ChartStatisticsComponent} from './chart-statistics/chart-statistics.component';
import {IncreaseDecreaseComponent} from './widget/increase-decrease/increase-decrease.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {ImageCropperModule} from 'ngx-image-cropper';
import {MyChartComponent} from './my-chart/my-chart.component';
import {ChartsModule} from 'ng2-charts';
import {MatDialogModule} from '@angular/material/dialog';
import {AlertDialogComponent} from './alert-dialog/alert-dialog.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {ChangePassComponent} from './auth/change-pass/change-pass.component';
import {CallbackComponent} from './callback/callback.component';
import {PricingComponent} from './pricing/pricing.component';
import {AutofocusDirective} from './directives/autofocus.directive';
import {ReminderComponent} from './reminder/reminder.component';
import {TourComponent} from './dialogs/tour/tour.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {LOCALE_ID} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {MatCoreModule} from './widget/mat-core/mat-core.module';
import {TimeSelectorComponent} from './widget/time-selector/time-selector.component';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

import localeIR from '@angular/common/locales/fa';
import {registerLocaleData} from '@angular/common';
import {LoginAsComponent} from './login-as/login-as.component';
import {ArchivesComponent} from './reminder/archives/archives.component';
import {MobileIntroComponent} from './dialogs/mobile-intro/mobile-intro.component';
import {MatStepperModule} from '@angular/material/stepper';
import {PromptComponentComponent} from './prompt-component/prompt-component.component';
import {PwaService} from './services/pwa.service';
import firebase from 'firebase';
import initializeApp = firebase.initializeApp;
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetModule, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import { IosPwaIntroComponent } from './pwa-intro/ios-pwa-intro/ios-pwa-intro.component';
import { AndroidPwaIntroComponent } from './pwa-intro/android-pwa-intro/android-pwa-intro.component';
import {NgNetStatusModule} from 'ng-net-status';
import { ImageEditorComponent } from './dialogs/image-editor/image-editor.component';
import { PaymentComponent } from './payment/payment.component';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { TodolistComponent } from './dialogs/todolist/todolist.component';
import { ReminderSetMobileComponent } from './dialogs/reminder-set-mobile/reminder-set-mobile.component';
import { StatisticsPopupComponent } from './dialogs/statistics-popup/statistics-popup.component';
import { TodoPreventComponent } from './dialogs/todo-prevent/todo-prevent.component';

registerLocaleData(localeIR);
const lang = 'fa-IR';
const initializer = (pwaService: PwaService) => () => pwaService.initPwaPrompt();
@NgModule({
  declarations: [
    AppComponent,
    TimerAndTaskComponent,
    BlogComponent,
    FeedbackComponent,
    StatisticsComponent,
    SettingComponent,
    FooterComponent,
    MenuComponent,
    ForDebugComponent,
    LoginComponent,
    ProfileComponent,
    ReversePipe,
    RegisterComponent,
    VerifyComponent,
    EditProfileComponent,
    HeaderComponent,
    ComingSoonComponent,
    PasswordComponent,
    ForgetPassComponent,
    OnlyNumberDirective,
    NumberLimitDirective,
    ChartStatisticsComponent,
    IncreaseDecreaseComponent,
    MyChartComponent,
    AlertDialogComponent,
    NotFoundComponent,
    ChangePassComponent,
    CallbackComponent,
    PricingComponent,
    AutofocusDirective,
    ReminderComponent,
    TourComponent,
    TimeSelectorComponent,
    LoginAsComponent,
    ArchivesComponent,
    MobileIntroComponent,
    PromptComponentComponent,
    IosPwaIntroComponent,
    AndroidPwaIntroComponent,
    ImageEditorComponent,
    PaymentComponent,
    TodolistComponent,
    ReminderSetMobileComponent,
    StatisticsPopupComponent,
    TodoPreventComponent,
  ],
  entryComponents: [AlertDialogComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        DragDropModule,
        MatChipsModule,
        MatFormFieldModule,
        MatIconModule,
        MatAutocompleteModule,
        FormsModule,
        ChartsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        CountdownModule,
        MatTableModule,
        MatSnackBarModule,
        ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
        MatButtonModule,
        HttpClientModule,
        PushNotificationsModule,
        NgxPaginationModule,
        NgxChartsModule,
        ImageCropperModule,
        MatMenuModule,
        MatDialogModule,
        MatDatepickerModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatCoreModule,
        ReactiveFormsModule,
        MatStepperModule,
        MatBottomSheetModule,
        ClipboardModule,
        AngularFireModule.initializeApp(environment.firebase),
        ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}),
        TranslateModule.forRoot({
            defaultLanguage: 'fa',
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        NgNetStatusModule
    ],
  providers: [Title, AppConfig, UserService,
    PreventLoginAccess, TaskService,
    NotificationService,
    {provide: LOCALE_ID, useValue: lang},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
